<hc-modal>
    <hc-modal-header>
        <span>Image — {{ img.fileName }}</span>
    </hc-modal-header>
    <hc-modal-body class="lightbox-body">
        <div *ngIf="imgLoading && !imgLoadFail" class="img-modal-loader">
            <hc-progress-spinner color="blue" [diameter]="80"></hc-progress-spinner>
        </div>
        <div *ngIf="!imgLoading && imgLoadFail" class="img-load-error">
            <div class="img-load-error-message">
                <div class="hc-empty-table-block">
                    <span class="hc-empty-table-block-ico hc-warn-ico"></span>
                    <span class="hc-empty-table-block-msg">There was an error loading your image. Try again.</span>
                    <button hc-button size="lg" (click)="getImage()">Reload Image</button>
                </div>
            </div>
        </div>
        <div *ngIf="imgData !== '' && !imgLoading" class="img-container">
            <img [src]="imgData | sanitizeImg" />
        </div>
    </hc-modal-body>
    <hc-modal-footer [minimal]="true"></hc-modal-footer>
</hc-modal>
